import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';

/**
 * Validates and potentially generates a valid project name
 * @param name - The project name to validate
 * @returns Promise<string> - A valid project name (may be the original or a modified version)
 */
export const getValidProjectName = async (name: string): Promise<string> => {
	try {
		// Call the validation endpoint which returns a valid project name as text/plain
		// This may return the original name if valid, or a corrected version if needed
		const url = `/rest/api/3/projectvalidate/validProjectName?name=${name}`;
		const validName = await fetch(url, getDefaultOptions(url)).then((res) => res.text());

		if (validName === null) {
			throw new Error('Unable to generate valid project name');
		}

		return validName;
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(`Unable to validate project name: ${error.message}`);
		}
		throw new Error('Unable to validate project name');
	}
};
